(function () {
  'use strict';

  function initReadMore() {
    document.querySelectorAll('[data-gf-readmore]').forEach(function (el) {
      var toggle = el.querySelector('[data-gf-readmore-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = el.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.textContent = isOpen ? 'Read less' : 'Read more';
      });
    });
  }

  function initReveal() {
    document.querySelectorAll('.gf-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initAutoMedia() {
    document.querySelectorAll('[data-gf-media-slug] .gf-media__img--auto').forEach(function (img) {
      var figure = img.closest('[data-gf-media-slug]');
      if (!figure) return;

      function markLoaded() {
        figure.classList.add('gf-media--loaded');
      }

      if (img.complete && img.naturalWidth > 0) {
        markLoaded();
      } else {
        img.addEventListener('load', markLoaded);
        img.addEventListener('error', function () {
          figure.classList.remove('gf-media--loaded');
        });
      }
    });
  }

  var GF_CURRENCY_DECIMALS = {
    BHD: 3, BIF: 0, BYR: 0, CLF: 4, CLP: 0, DJF: 0, GNF: 0, IQD: 3, ISK: 0,
    JOD: 3, JPY: 0, KMF: 0, KRW: 0, KWD: 3, LYD: 3, MRO: 5, OMR: 3, PYG: 0,
    RWF: 0, TND: 3, UGX: 0, UYI: 0, UYW: 4, VND: 0, VUV: 0, XAF: 0, XAG: 0,
    XAU: 0, XBA: 0, XBB: 0, XBC: 0, XBD: 0, XDR: 0, XOF: 0, XPD: 0, XPF: 0,
    XPT: 0, XSU: 0, XTS: 0, XUA: 0
  };

  function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor) {
    var roundedNumber = (moneyValue / divisor).toFixed(precision);
    var parts = roundedNumber.split('.');
    var whole = parts[0] || '0';
    var fraction = parts[1] || '';
    whole = whole.replace(/\d(?=(\d\d\d)+(?!\d))/g, function (digit) {
      return digit + thousandsSeparator;
    });
    return precision <= 0 ? whole : whole + decimalSeparator + fraction.padEnd(precision, '0');
  }

  function getMoneySettings() {
    var scope = document.querySelector('[data-gf-money-format]');
    return {
      format: scope && scope.dataset.gfMoneyFormat,
      currency: (scope && scope.dataset.gfCurrency) || 'EUR'
    };
  }

  function formatMoney(cents, format, currency) {
    var settings = getMoneySettings();
    var moneyFormat = format || settings.format;
    var moneyCurrency = (currency || settings.currency || 'EUR').toUpperCase();

    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && moneyFormat) {
      return Shopify.formatMoney(cents, moneyFormat);
    }

    if (!moneyFormat) moneyFormat = '€{{amount_with_comma_separator}}';

    var currencyPrecision = Object.prototype.hasOwnProperty.call(GF_CURRENCY_DECIMALS, moneyCurrency)
      ? GF_CURRENCY_DECIMALS[moneyCurrency]
      : 2;
    var divisor = Math.pow(10, currencyPrecision);

    return moneyFormat.replace(/{{\s*(\w+)\s*}}/g, function (_, placeholder) {
      var thousandsSeparator = ',';
      var decimalSeparator = '.';
      var precision = currencyPrecision;

      switch (placeholder) {
        case 'amount':
          break;
        case 'amount_no_decimals':
          precision = 0;
          break;
        case 'amount_with_comma_separator':
          thousandsSeparator = '.';
          decimalSeparator = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          thousandsSeparator = '.';
          precision = 0;
          break;
        case 'amount_no_decimals_with_space_separator':
          thousandsSeparator = ' ';
          precision = 0;
          break;
        case 'amount_with_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousandsSeparator = '\'';
          decimalSeparator = '.';
          break;
        case 'currency':
          return moneyCurrency;
        default:
          break;
      }

      return formatCents(cents, thousandsSeparator, decimalSeparator, precision, divisor);
    });
  }

  function initProductHotspots() {
    var root = document.querySelector('[data-gf-product-hotspots]');
    if (!root || root.classList.contains('gf-pdp-hotspots--disabled')) return;

    var hotspots = Array.prototype.slice.call(root.querySelectorAll('[data-gf-hotspot]'));
    if (!hotspots.length) return;

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function closeAll() {
      hotspots.forEach(function (spot) {
        spot.classList.remove('is-active');
        var trigger = spot.querySelector('[data-gf-hotspot-trigger]');
        var card = spot.querySelector('[data-gf-hotspot-card]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (card) card.hidden = true;
      });
      root.querySelectorAll('[data-gf-hotspot-rail]').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
    }

    function openSpot(spot) {
      if (!spot) return;
      closeAll();
      spot.classList.add('is-active');
      var trigger = spot.querySelector('[data-gf-hotspot-trigger]');
      var card = spot.querySelector('[data-gf-hotspot-card]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (card) card.hidden = false;

      var cardId = card && card.id;
      if (cardId) {
        root.querySelectorAll('[data-gf-hotspot-rail]').forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-hotspot-target') === cardId);
        });
      }
    }

    hotspots.forEach(function (spot) {
      var trigger = spot.querySelector('[data-gf-hotspot-trigger]');
      var card = spot.querySelector('[data-gf-hotspot-card]');
      if (!trigger || !card) return;

      if (canHover) {
        spot.addEventListener('mouseenter', function () { openSpot(spot); });
        spot.addEventListener('mouseleave', function () { closeAll(); });
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (spot.classList.contains('is-active')) closeAll();
        else openSpot(spot);
      });
    });

    root.querySelectorAll('[data-gf-hotspot-rail]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = btn.getAttribute('data-hotspot-target');
        var spot = hotspots.find(function (item) {
          var card = item.querySelector('[data-gf-hotspot-card]');
          return card && card.id === targetId;
        });
        if (!spot) return;
        if (spot.classList.contains('is-active')) closeAll();
        else openSpot(spot);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  function getTunaMagnetProductMeta() {
    var jsonEl = document.getElementById('gf-product-json');
    if (!jsonEl) return { handle: 'tuna-magnet', productId: null };
    try {
      var product = JSON.parse(jsonEl.textContent);
      return {
        handle: (product && product.handle) || 'tuna-magnet',
        productId: product && product.id
      };
    } catch (e) {
      return { handle: 'tuna-magnet', productId: null };
    }
  }

  function isHandlingFeeLine(item) {
    if (!item) return false;
    var handle = item.handle || '';
    if (handle === 'chargefee-order-fees' || handle === 'handling-fee') return true;
    if (handle.indexOf('chargefee') === 0) return true;
    var props = item.properties || {};
    if (props._chargefee_parent_fee_engine || props['_chargefee_parent_fee_engine']) return true;
    return false;
  }

  function isTunaMagnetLine(item, meta) {
    if (!item) return false;
    // Never treat Chargefee / handling-fee lines as magnets — those must stay in the cart.
    if (isHandlingFeeLine(item)) return false;
    if (meta.handle && item.handle === meta.handle) return true;
    if (meta.productId && item.product_id === meta.productId) return true;
    if (item.handle === 'tuna-magnet') return true;
    return false;
  }

  /** Zero only Tuna Magnet line items. Handling fees and other products are left untouched. */
  function removeTunaMagnetLines(root, meta) {
    return fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (isTunaMagnetLine(item, meta)) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return cart;

        // Atomic update of tuna keys only — never cart/clear.js (that would wipe handling fees).
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).then(function (response) { return response.json(); });
      });
  }

  function countTunaMagnetQty(cart, meta) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (isTunaMagnetLine(item, meta) ? (item.quantity || 0) : 0);
    }, 0);
  }

  // Always strip existing Tuna Magnet lines before preorder add (keeps upcharges / other products).
  var GF_CLEAR_TUNA_BEFORE_PREORDER = true;

  function submitPreorderCheckout(variantId, quantity, submitButtons) {
    var root = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var buttons = submitButtons || [];
    var tunaMeta = getTunaMagnetProductMeta();
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    var vid = parseInt(variantId, 10);

    if (!vid) {
      console.warn('GF preorder checkout: missing variant id');
      return Promise.reject(new Error('missing-variant'));
    }

    buttons.forEach(function (btn) {
      btn.disabled = true;
      if (btn.dataset.gfBuyNow !== undefined || btn.hasAttribute('data-gf-buy-now')) {
        btn.setAttribute('aria-busy', 'true');
        if (!btn.dataset.gfBuyNowLabel) btn.dataset.gfBuyNowLabel = btn.textContent;
        btn.textContent = 'Processing…';
      }
    });

    function restoreButtons() {
      buttons.forEach(function (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (btn.dataset.gfBuyNowLabel) btn.textContent = btn.dataset.gfBuyNowLabel;
      });
    }

    function addTuna() {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: vid,
            quantity: qty,
            properties: { Fulfillment: 'Ready to ship' }
          }]
        })
      }).then(function (response) { return response.json(); });
    }

    function verifyTunaQty() {
      return fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var tunaQty = countTunaMagnetQty(cart, tunaMeta);
          if (tunaQty === qty) return cart;

          // Still stacked or empty — force exact qty via key updates + re-add if needed.
          var updates = {};
          (cart.items || []).forEach(function (item) {
            if (isTunaMagnetLine(item, tunaMeta)) updates[item.key] = 0;
          });

          var clearPromise = Object.keys(updates).length
            ? fetch(root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ updates: updates })
              }).then(function (response) { return response.json(); })
            : Promise.resolve();

          return clearPromise.then(addTuna).then(function (data) {
            if (data.status && data.status >= 400) {
              throw new Error(data.description || 'Unable to start checkout');
            }
            return data;
          });
        });
    }

    var checkoutFlow = Promise.resolve();

    if (GF_CLEAR_TUNA_BEFORE_PREORDER) {
      checkoutFlow = checkoutFlow.then(function () {
        return removeTunaMagnetLines(root, tunaMeta);
      });
    }

    return checkoutFlow
      .then(addTuna)
      .then(function (data) {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || 'Unable to start checkout');
        }
      })
      .then(verifyTunaQty)
      .then(function () {
        window.location.href = root + 'checkout';
      })
      .catch(function (err) {
        restoreButtons();
        console.warn('GF preorder checkout failed:', err);
        throw new Error('checkout-failed');
      });
  }

  function getPreorderFormContext(form) {
    if (!form) return null;
    var variantInput = form.querySelector('[data-gf-variant-id]');
    if (!variantInput) return null;
    var qtyInput = form.querySelector('[name="quantity"]');
    var formId = form.getAttribute('id');
    var submitButtons = form.querySelectorAll(
      '[type="submit"], [type="button"][data-gf-buy-now], [form="' + formId + '"]'
    );
    return {
      form: form,
      variantId: variantInput.value,
      quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
      buttons: submitButtons
    };
  }

  /** Capture-phase handlers so native /cart/add never stacks magnets. */
  function initPreorderCheckoutDelegation() {
    if (document.documentElement.dataset.gfCheckoutDelegation === '1') return;
    document.documentElement.dataset.gfCheckoutDelegation = '1';

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.hasAttribute('data-gf-product-form')) return;
      event.preventDefault();
      event.stopPropagation();
      var ctx = getPreorderFormContext(form);
      if (!ctx) return;
      submitPreorderCheckout(ctx.variantId, ctx.quantity, ctx.buttons).catch(function () {});
    }, true);

    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest
        ? event.target.closest('[data-gf-buy-now], .gf-sticky-cart__btn, .gf-preorder-sticky__btn')
        : null;
      if (!btn || btn.disabled) return;

      var form = btn.form || document.querySelector('[data-gf-product-form]');
      if (!form || !form.hasAttribute('data-gf-product-form')) return;

      event.preventDefault();
      event.stopPropagation();

      var ctx = getPreorderFormContext(form);
      if (!ctx) return;
      submitPreorderCheckout(ctx.variantId, ctx.quantity, ctx.buttons).catch(function () {});
    }, true);
  }

  function initPreorderPage() {
    var page = document.querySelector('[data-gf-preorder-page]');
    if (!page) return;

    var form = page.querySelector('[data-gf-product-form]');
    var qtyInput = page.querySelector('#gf-preorder-quantity');
    var qtyWrap = page.querySelector('[data-gf-preorder-qty]');

    function syncOptionCards() {
      if (!form) return;
      var checked = form.querySelector('[data-gf-option-input]:checked');
      page.querySelectorAll('[data-gf-preorder-option]').forEach(function (card) {
        var input = card.querySelector('[data-gf-option-input]');
        card.classList.toggle('is-selected', !!(checked && input === checked));
      });
    }

    function applySetupFromQuery() {
      if (!form) return;
      var setup = new URLSearchParams(window.location.search).get('setup');
      if (!setup) return;

      var targetValue = null;
      var normalized = setup.toLowerCase().replace(/[\s_+]+/g, '-');
      if (normalized === 'in-hull' || normalized === 'inhull' || normalized === 'overboard') {
        var inHullCard = page.querySelector('[data-gf-preorder-option].gf-preorder-option--featured');
        if (inHullCard) targetValue = inHullCard.dataset.gfVariantOption;
      } else if (normalized === 'water' || normalized === 'water-only') {
        var waterCard = page.querySelector('[data-gf-preorder-option]:not(.gf-preorder-option--featured)');
        if (waterCard) targetValue = waterCard.dataset.gfVariantOption;
      } else {
        targetValue = setup;
      }

      if (!targetValue) return;
      form.querySelectorAll('[data-gf-option-input]').forEach(function (input) {
        if (input.value === targetValue) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      syncOptionCards();
    }

    if (form) {
      form.querySelectorAll('[data-gf-option-input]').forEach(function (input) {
        input.addEventListener('change', syncOptionCards);
      });
      syncOptionCards();
      applySetupFromQuery();
    }

    if (qtyWrap && qtyInput) {
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 5;
      var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;

      function clampQty(value) {
        return Math.min(max, Math.max(min, value));
      }

      qtyWrap.querySelectorAll('[data-gf-qty-minus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          qtyInput.value = clampQty((parseInt(qtyInput.value, 10) || 1) - 1);
        });
      });

      qtyWrap.querySelectorAll('[data-gf-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          qtyInput.value = clampQty((parseInt(qtyInput.value, 10) || 1) + 1);
        });
      });

      qtyInput.addEventListener('change', function () {
        qtyInput.value = clampQty(parseInt(qtyInput.value, 10) || 1);
      });
    }
  }

  function initProductPage() {
    var jsonEl = document.getElementById('gf-product-json');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var form = document.querySelector('[data-gf-product-form]');
    var variantInput = document.querySelector('[data-gf-variant-id]');
    var priceEl = document.querySelector('[data-gf-product-price]');
    var mainImg = document.getElementById('gf-pdp-main-image');
    var stickyPrice = document.querySelector('.gf-sticky-cart__price');
    var preorderStickyPrice = document.querySelector('[data-gf-preorder-sticky-price]');
    var moneySettings = getMoneySettings();

    function findVariant() {
      if (!form || product.variants.length <= 1) return product.variants[0];
      var selected = {};
      form.querySelectorAll('[data-gf-option-input]:checked').forEach(function (input) {
        selected[input.name.replace('options[', '').replace(']', '')] = input.value;
      });
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === selected['options[' + product.options[i] + ']'] || opt === selected[product.options[i]];
        });
      }) || product.variants[0];
    }

    function sizedImageUrl(src, width) {
      if (!src) return src;
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      return src.replace(/([&?])width=\d+/g, '$1').replace(/[&?]$/, '') + sep + 'width=' + width;
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneySettings.format, moneySettings.currency);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneySettings.format, moneySettings.currency);
      if (preorderStickyPrice) preorderStickyPrice.textContent = formatMoney(variant.price, moneySettings.format, moneySettings.currency);
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        // srcset overrides src, so it must be rewritten too for the image to change.
        mainImg.srcset = [375, 550, 750, 1100, 1500]
          .map(function (w) { return sizedImageUrl(src, w) + ' ' + w + 'w'; })
          .join(', ');
        mainImg.src = sizedImageUrl(src, 1400);
        if (variant.featured_image.alt) mainImg.alt = variant.featured_image.alt;
      }
    }

    if (form) {
      form.querySelectorAll('[data-gf-option-input]').forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });
    }

    document.querySelectorAll('[data-gf-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-gf-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (mainImg && btn.dataset.src) mainImg.src = btn.dataset.src;
      });
    });

    function selectVariantOption(optionValue) {
      if (!form || !optionValue) return;
      var matched = false;
      form.querySelectorAll('[data-gf-option-input]').forEach(function (input) {
        if (input.value === optionValue) {
          input.checked = true;
          matched = true;
        }
      });
      if (matched) updateVariant();
      document.querySelectorAll('[data-gf-variant-card]').forEach(function (card) {
        card.classList.toggle('is-active', card.dataset.gfVariantOption === optionValue);
      });
    }

    document.querySelectorAll('[data-gf-variant-select]').forEach(function (link) {
      link.addEventListener('click', function () {
        selectVariantOption(link.dataset.gfVariantSelect);
      });
    });

    if (form) {
      form.querySelectorAll('[data-gf-option-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          document.querySelectorAll('[data-gf-variant-card]').forEach(function (card) {
            card.classList.toggle('is-active', card.dataset.gfVariantOption === input.value);
          });
        });
      });
      var checked = form.querySelector('[data-gf-option-input]:checked');
      if (checked) {
        document.querySelectorAll('[data-gf-variant-card]').forEach(function (card) {
          card.classList.toggle('is-active', card.dataset.gfVariantOption === checked.value);
        });
      }
    }
  }

  function fixTransparentHeaderHeight() {
    var header = document.querySelector('#header-component');
    var headerGroup = document.querySelector('#header-group');
    if (!header || !header.hasAttribute('transparent') || !headerGroup) return;

    var announcementHeight = 0;
    var children = headerGroup.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === header || !(el instanceof HTMLElement)) continue;
      announcementHeight += el.offsetHeight;
    }

    document.body.style.setProperty(
      '--header-group-height',
      (announcementHeight + header.offsetHeight) + 'px'
    );
  }

  function boot() {
    initPreorderCheckoutDelegation();
    initReadMore();
    initReveal();
    initAutoMedia();
    initProductHotspots();
    initProductPage();
    initPreorderPage();
    fixTransparentHeaderHeight();
    window.addEventListener('resize', fixTransparentHeaderHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
